const p = /* @__PURE__ */ new WeakSet();
let f = false, h = false;
function E(e = document) {
  e.querySelectorAll("recharge-subscription-widget").forEach((t) => {
    m(t);
  }), g(), y();
}
function m(e) {
  p.has(e) || (p.add(e), b(e, (t) => {
    const r = () => {
      window.requestAnimationFrame(() => {
        i(e);
      }), window.setTimeout(() => {
        i(e);
      }, 80), window.setTimeout(() => {
        i(e);
      }, 200);
    };
    t.addEventListener("click", r, true), t.addEventListener("change", r, true), new MutationObserver(r).observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ["checked", "rc-selected", "rc-not-selected", "data-checked", "part"] }), r();
  }));
}
function g() {
  f || (f = true, window.addEventListener("product:price-state-request", () => {
    S();
  }));
}
function y() {
  if (h) return;
  h = true, new MutationObserver(() => {
    document.querySelectorAll("recharge-subscription-widget").forEach((t) => {
      m(t);
    });
  }).observe(document.body, { childList: true, subtree: true });
}
function S() {
  document.querySelectorAll("recharge-subscription-widget").forEach((e) => {
    i(e);
  });
}
function i(e) {
  var _a, _b, _c;
  const t = ((_a = window.SubscriptionWidgetConfig) == null ? void 0 : _a.formattedPrices) || {}, r = q(e);
  if (!r) {
    o(0, false);
    return;
  }
  const n = t[String(r)];
  if (!n) {
    o(0, false);
    return;
  }
  const c = e.shadowRoot;
  if (!c) {
    o(0, false);
    return;
  }
  if ((((_b = a(c, 'input[name="purchaseOption"]:checked')) == null ? void 0 : _b.value) || "") !== "subscription") {
    o(0, false);
    return;
  }
  const v = ((_c = a(c, 'input[name="rc_plan"]:checked')) == null ? void 0 : _c.value) || "", d = s(n.unit || ""), l = P(n, v);
  if (!d || !l) {
    o(0, true);
    return;
  }
  const w = l - d;
  o(w, true);
}
function P(e, t) {
  var _a, _b;
  const r = t ? (_b = (_a = e.sellingPlans) == null ? void 0 : _a[t]) == null ? void 0 : _b.price : "";
  return s(r || e.discounted || "");
}
function o(e, t) {
  window.dispatchEvent(new CustomEvent("product:option-price-change", { detail: { key: "recharge", price: e } })), window.dispatchEvent(new CustomEvent("product:recharge-state-change", { detail: { isSubscription: t, priceDelta: e } }));
}
function q(e) {
  var _a, _b;
  const n = ((_b = (_a = e.closest("form") || document.querySelector('form[action*="/cart/add"]')) == null ? void 0 : _a.querySelector('input[name="id"], select[name="id"]')) == null ? void 0 : _b.value) || e.getAttribute("default-variant-id") || "";
  return Number(n);
}
function s(e) {
  const r = String(e || "").replace(/\s+/g, "").replace(",", ".").match(/-?\d+(\.\d+)?/);
  if (!r) return 0;
  const n = Number(r[0]);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}
function b(e, t, r = 0) {
  if (e.shadowRoot) {
    t(e.shadowRoot);
    return;
  }
  r > 40 || window.setTimeout(() => {
    b(e, t, r + 1);
  }, 100);
}
function a(e, t) {
  const r = e.querySelector(t);
  if (r) return r;
  const n = e.querySelectorAll("*");
  for (const c of n) {
    if (!c.shadowRoot) continue;
    const u = a(c.shadowRoot, t);
    if (u) return u;
  }
  return null;
}
export {
  E as i
};
